"use strict";

exports.__esModule = true;
exports.rewriteLinkPath = void 0;

var _utils = require("@gatsbyjs/reach-router/lib/utils");

var _applyTrailingSlashOption = require("gatsby-page-utils/apply-trailing-slash-option");

var _parsePath2 = require("./parse-path");

var _isLocalLink = require("./is-local-link");

var _ = require(".");

// Specific import to treeshake Node.js stuff
var isAbsolutePath = function isAbsolutePath(path) {
  return path === null || path === void 0 ? void 0 : path.startsWith("/");
};

var getGlobalTrailingSlash = function getGlobalTrailingSlash() {
  return typeof __TRAILING_SLASH__ !== "undefined" ? __TRAILING_SLASH__ : undefined;
};

function absolutify(path, current) {
  // If it's already absolute, return as-is
  if (isAbsolutePath(path)) {
    return path;
  }

  return (0, _utils.resolve)(path, current);
}

var rewriteLinkPath = function rewriteLinkPath(path, relativeTo) {
  if (typeof path === "number") {
    return path;
  }

  if (!(0, _isLocalLink.isLocalLink)(path)) {
    return path;
  }

  var _parsePath = (0, _parsePath2.parsePath)(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  var option = getGlobalTrailingSlash();
  var adjustedPath = path;

  if (option === "always" || option === "never") {
    var output = (0, _applyTrailingSlashOption.applyTrailingSlashOption)(pathname, option);
    adjustedPath = "" + output + search + hash;
  }

  return isAbsolutePath(adjustedPath) ? (0, _.withPrefix)(adjustedPath) : absolutify(adjustedPath, relativeTo);
};

exports.rewriteLinkPath = rewriteLinkPath;